module.exports = [require("./BajaNorte.js"), require("./BajaSur.js"), require("./General.js")];